import React, { useState } from "react";
import "react-phone-number-input/style.css";
import "@/styles/phone.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

type Props = {
  handleChange: any;
  phone: string;
  error: string;
  touched: boolean;
  isDisabled?: boolean;
  autoComplete?: string;
};
function Phone({
  handleChange,
  phone,
  error,
  touched,
  isDisabled,
  autoComplete,
}: Props) {
  const showError =
    touched && (error || (phone && !isValidPhoneNumber(phone || "")));
  return (
    <>
      <PhoneInput
        international
        countryCallingCodeEditable={false}
        defaultCountry="US"
        disabled={isDisabled}
        placeholder={"Phone number"}
        value={phone || ""}
        onChange={handleChange}
        style={{
          border: showError ? "1px solid #FDA29B" : "1px solid #A5A5A6",
          borderRadius: "6px",
          paddingLeft: "10px",
          paddingTop: "1px",
          paddingBottom: "1px",
          width: "inherit",
          height: "42px",
          fontWeight: 400,
          fontSize: "16px",
          color: "#1E1E20",
          marginTop: "3px",
          background: "white",
          backgroundColor: isDisabled ? "#f9fafb" : "white",
          placeholderText: "16px",
        }}
        autoComplete={autoComplete || "on"}
        // countrySelectComponent={CustomCountrySelect}
        // className="custom-phone-input"
        countrySelectComponent={(props) => (
          <CustomCountrySelect
            {...props}
            onChange={(val) => {
              // setSelectedCountry(val); // Update initials when selected
              props.onChange(val);
            }}
          />
        )}
      />
      {showError && (
        <p className="text-base text-error-500 mt-1">
          {error || "Please enter correct number"}
        </p>
      )}
    </>
  );
}

const CustomCountrySelect = ({ value, onChange, options }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="custom-select border-none focus:ring-0 focus:outline-none"
  >
    {options.map(({ value }) => (
      <option key={value} value={value}>
        {value}
      </option>
    ))}
  </select>
);

export default React.memo(Phone);
